import './IconPlusCircle.css';
import React from 'react';
var IconPlusCircle = function IconPlusCircle(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 18 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 18 : _ref$height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    className: "".concat(className, " ").concat(styles)
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_923",
    "data-name": "Ellipse 923",
    fill: "none",
    stroke: "#035e88",
    strokeWidth: "1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "9",
    r: "9",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "9",
    r: "8.5",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16914-2",
    "data-name": "Group 16914",
    transform: "translate(5 5.001)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_370",
    "data-name": "Line 370",
    y2: "8",
    transform: "translate(4)",
    fill: "none",
    stroke: "#035e88",
    strokeLinecap: "round",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_371",
    "data-name": "Line 371",
    x1: "8",
    transform: "translate(0 4)",
    fill: "none",
    stroke: "#035e88",
    strokeLinecap: "round",
    strokeWidth: "1"
  })));
};
var styles = "sjsmq9m";
export default IconPlusCircle;